import {useCallback, useState} from 'react'
import {toast} from 'react-toastify'
import {apiConstants, postGeneric} from '../../common/constants'
import {getMerchant} from '../../helpers/ReduxHelpers'

export function useCreatePackage({onSuccess, packageId}) {
  const [isCreating, setIsCreating] = useState(false)

  const uploadImage = useCallback(async (file) => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await postGeneric(apiConstants.UPLOAD_REMARK, formData)
    return response.data.file_url
  }, [])

  const createPackage = useCallback(
    async (data) => {
      try {
        const request = {
          ...data,
          merchant_oid: getMerchant().id,
          box_name: `${data.box_name} - ${data.box_type}`,
        }

        for (const [index, image] of (data.image || []).entries()) {
          const property = [`image_name_${index + 1}`]
          const imageUrl = await uploadImage(image)
          if (request.box_image_url) {
            request.box_image_url[property] = imageUrl
          } else {
            request.box_image_url = {[property]: imageUrl}
          }
        }

        delete request.image
        delete request.box_type

        // Considering the packageId is not null, we are updating the package
        if (packageId) {
          request.id = packageId
        }

        const url = packageId ? apiConstants.UPDATE_PACKAGE : apiConstants.CREATE_PACKAGE
        await postGeneric(url, request)
        toast.success(packageId ? 'Package updated successfully' : 'Package created successfully')
        onSuccess?.()
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong')
      } finally {
        setIsCreating(false)
      }
    },
    [uploadImage, onSuccess, packageId]
  )

  return {createPackage, isCreating}
}
